
<div>
  <product-category-header style="margin-top: 70px"
                           :current-category="current_category"
                           :parent-category="parent_category"
                           v-on:category-selected="selectCategory"></product-category-header>
  <product-category-subcategory-cards v-if="current_category.ui_template === CATEGORY_UI_TEMPLATES.SUBCATEGORY_CARDS.value"
                                      :category="current_category"
                                      :subcategories="items"
                                      v-on:category-selected="selectCategory"></product-category-subcategory-cards>
  <product-category-non-bto-structure-only v-if="current_category.ui_template === CATEGORY_UI_TEMPLATES.NON_BTO_STRUCTURE_ONLY.value"
                                           :category="current_category"
                                           :is-public="isPublic"
                                           :category_assignments="category_assignments"></product-category-non-bto-structure-only>
  <product-category-non-bto-and-bto-list v-if="current_category.ui_template === CATEGORY_UI_TEMPLATES.NON_BTO_STRUCTURE_BTO_SUBCATEGORY.value"
                                         :category="current_category"
                                         :subcategories="items"
                                         :is-public="isPublic"
                                         :category_assignments="category_assignments"
                                         v-on:category-selected="selectCategory"></product-category-non-bto-and-bto-list>
  <product-category-bto-structure-list v-if="current_category.ui_template === CATEGORY_UI_TEMPLATES.BTO_STRUCTURE_LIST.value"
                                         :category="current_category"
                                         :subcategories="items"
                                         :is-public="isPublic"
                                         :category-assignments="category_assignments"></product-category-bto-structure-list>
  <yega1-axios-data-source ref="data_source"
                           store-name="ConfigurationCategoriesStore"
                           :initial-load="!!$route.params.parent_category_id"
                           :store-query="{parent_category_id: $route.params.parent_category_id}"></yega1-axios-data-source>
  <yega1-axios-show-data-source store-name="ConfigurationCategoriesStore"
                                :store-parameter="''+$route.params.parent_category_id"
                                :initial-load="!!$route.params.parent_category_id"
                                v-on:item-loaded = "handleCategoryShowLoaded"
                                ref="show_data_source"
  ></yega1-axios-show-data-source>
</div>
